import { UserApiClient } from '../UserApiClient';
export const UserInfoApi = UserApiClient.injectEndpoints({
    endpoints: (build) => ({
        getUserDetails: build.query({
            query: () => ({
                url: 'userinfo',
            }),
        }),
    }),
});
export const { useGetUserDetailsQuery } = UserInfoApi;
//# sourceMappingURL=UserInfoApi.js.map